export class CommonModel {
    userid: number;
    lan: string;
    token:any;
}
